import { Field, UUID } from '@indigohive/cogfy-types'
import { GetRecordByIdResult } from '@indigohive/cogfy-types/endpoints/getRecordById'
import { UpdateRecordPropertiesOperationData } from '@indigohive/cogfy-types/endpoints/transactions'
import clsx from 'clsx'
import { createElement } from 'react'
import { FIELD_ICONS_BY_TYPE, RecordPropertyContent } from '../../field-types'
import { RecordPropertyError } from './componentes/RecordPropertyError'
import { RecordPropertyLoading } from './componentes/RecordPropertyLoading'
import { RecordPropertyStale } from './componentes/RecordPropertyStale'

export type RecordPropertyProps = {
  record: GetRecordByIdResult
  field: Field
  collectionId: UUID
  canEdit: boolean
  onFieldNameClick?: (e: any) => void
  onUpdateRecordProperties?: (data: UpdateRecordPropertiesOperationData) => void
  onRecalculateClick?: () => void
  loading?: boolean
  stale?: boolean
  error?: boolean
}

export function RecordProperty (props: RecordPropertyProps) {
  const { record, field, collectionId, canEdit, onFieldNameClick, onUpdateRecordProperties, onRecalculateClick, loading, stale, error } = props

  const fieldName = field.name.length > 50 ? field.name.substring(0, 50) + '...' : field.name

  return (
    <div key={field.id} className="max-w-full">
      <div className="flex justify-between items-center">
        <button
          className={clsx(
            'btn btn-xs btn-ghost text-xs px-0 py-3 my-1',
            error && 'text-error',
            stale && !error && 'text-warning'
          )}
          onClick={onFieldNameClick}
        >
          {createElement(FIELD_ICONS_BY_TYPE[field.type], { size: 16 })}
          {fieldName}
        </button>

        {loading && <RecordPropertyLoading />}
        {error && <RecordPropertyError onRecalculateClick={onRecalculateClick} message={record.properties[field.id]?.error?.message} />}
        {stale && !error && <RecordPropertyStale onRecalculateClick={onRecalculateClick} />}
      </div>
      <RecordPropertyContent
        collectionId={collectionId}
        field={field}
        record={record}
        onUpdateRecordProperties={onUpdateRecordProperties}
        disabled={!canEdit || loading || error}
        stale={stale}
        error={error}
        canEdit={canEdit}
      />
    </div>
  )
}
